import React from "react";
import "./header.css";
import { PartnerLogo } from "../../features/partnerLogo/partnerLogoTypes";
import { RowFlexBox } from "../common/FlexBoxes";
import { useTheme } from "@emotion/react";

const Header: React.FC<PartnerLogo> = (partnerLogo: PartnerLogo) => {
  const theme = useTheme();

  return (
    <RowFlexBox
      style={{
        padding: "24px",
        ...(partnerLogo.slug === "amp" ? { background: theme.tokens.global.themeColorBackgroundInverse } : {}),
      }}
    >
      <RowFlexBox
        style={{
          maxWidth: 1080,
          alignItems: "flex-start",
          justifyContent: "flex-start",
        }}
      >
        <a className={"icon-link"} href={`/${partnerLogo.slug ? partnerLogo.slug : ""}`}>
          {partnerLogo.url ? (
            <RowFlexBox
              style={{
                alignItems: "flex-start",
                justifyContent: "flex-start",
              }}
            >
              <div className={"img-container"}>
                <img src={partnerLogo.url} alt={partnerLogo.slug} />
              </div>
            </RowFlexBox>
          ) : (
            <img src={process.env.PUBLIC_URL + "/TAL.svg"} width="65px" height="24px" alt={"TAL Logo"} />
          )}
        </a>
      </RowFlexBox>
    </RowFlexBox>
  );
};

export default Header;
